module.exports = __webpack_public_path__ + "static/media/download-icon.74dde6e6.png";